import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({ allowedRoles, children }) => {
    const userType = sessionStorage.getItem("usertype");
    const token = sessionStorage.getItem("usertoken");
  
    if (!token) return <Navigate to="/login" replace />;
    if (!allowedRoles.includes(userType)) return <Navigate to="/unauthorized" replace />;
    return children;
  };

export default RequireAuth;